import axios from "axios";

// Calls our own serverless function (netlify/functions/watchlist.mjs) rather
// than the price API directly. That one request is shared by every visitor
// through the durable CDN cache, which is what stops the page's upstream cost
// growing with its traffic - calling out from here once spent a whole month's
// allowance. The function's own comment explains why it has to be a serverless
// function and not an edge one.
//
// Returns null rather than [] when the data cannot be had. The difference
// matters to the caller: [] is "the list is empty", null is "we still don't
// know", and only the first should be allowed to clear the table.
export const getWatchlistApi = async () => {
  try {
    const response = await axios.get("/api/watchlist");

    if (!Array.isArray(response.data)) {
      console.error("Unexpected watchlist response:", response.data);
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Watchlist fetch failed:", error);
    return null;
  }
};
